<template>
  <div>
    <div v-if="treeData.length">
      <Draggable
        class="ml-3"
        :treeData="treeData"
        textKey="title"
        :ondragend="validateMove"
        @drop="updateTree"
        :rootDraggable="false"
        :rootDroppable="false"
      >
        <template v-slot="{ node }">
          <v-hover style="cursor: pointer" v-slot="{ hover }">
            <v-list-item @click="navigateToDocument(node)">
              <div>
                <span>{{ node.title }}</span>
                <v-btn
                  v-if="hover"
                  icon
                  right
                  absolute
                  x-small
                  dark
                  color="blue darken-4"
                  depressed
                  class="mr-8"
                  @click="showAddDocumentDialog(node)"
                >
                  <v-icon size="15px">mdi-plus</v-icon>
                </v-btn>
                <v-btn
                  dark
                  icon
                  right
                  absolute
                  x-small
                  color="red darken-4"
                  depressed
                  v-if="hover && node.path.split('/').length !== 2"
                  @click="showRemoveDocumentDialog(node)"
                >
                  <v-icon size="15px">mdi-close</v-icon>
                </v-btn>
              </div>
            </v-list-item>
          </v-hover>
        </template>
      </Draggable>
      <v-dialog v-model="openRemoveDocumentDialog" max-width="500px">
        <v-card>
          <v-card-title class="mx-auto red darken-4">
            Are you sure you want to remove this document: <br />
            {{ parent.path }}
          </v-card-title>
          <v-card-actions>
            <v-btn @click="openRemoveDocumentDialog = false">Cancel</v-btn>
            <v-spacer />
            <v-btn
              @click="deleteActiveDocument(parent.path)"
              color="red darken-4 white--text"
              >Remove</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div v-else>
      <v-list-item @click="showAddDocumentDialog(null)">
        <v-list-item-title> Create first document... </v-list-item-title>
      </v-list-item>
    </div>
    <v-dialog dense v-model="openNewDocumentDialog" max-width="800px">
      <v-card>
        <v-card-title class="mx-auto orange darken-2">
          Add new document under: <br />
          {{ parent.path }}
        </v-card-title>
        <v-card-text>
          <br />
          <v-text-field
            label="Title"
            @input="newDocumentTitleError = null"
            v-model="newDocumentTitle"
          />
          <p
            v-if="newDocumentTitleError"
            v-text="newDocumentTitleError"
            class="red--text"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="createDocument">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import "@he-tree/vue2/dist/he-tree-vue2.css";
import { Draggable } from "@he-tree/vue2";
import store from "@/store";
import router from "@/router";
import documentCache from "../../../api/_lib/utils/documentCache";
import _ from "lodash";

export default {
  components: { Draggable },
  props: { treeData: Array },
  data() {
    return {
      openNewDocumentDialog: false,
      openRemoveDocumentDialog: false,
      newDocumentTitle: "New document",
      newDocumentTitleError: null,
      parent: {},
      documentId: null,
      processing: false,
    };
  },
  methods: {
    async updateTree(e) {
      if (e.dragChanged) {
        const droppedDocumentId = e.draggingNode.documentId;

        const copyOfActiveSpaceTree = JSON.parse(
          JSON.stringify(store.state.activeSpace.tree)
        );

        copyOfActiveSpaceTree.children = e.targetTree.outputNestedData();

        const { documentPathCache, documentIdCache } = documentCache(
          copyOfActiveSpaceTree.children[0]
        );
        delete documentPathCache[copyOfActiveSpaceTree.path];
        const newParentPath = _.get(documentIdCache, droppedDocumentId)
          .path.split("/")
          .slice(0, -1)
          .join("/");
        const newChildIndex = e.targetTree
          .outputFlatData()
          .map((doc) => doc.documentId)
          .indexOf(droppedDocumentId);
        await store.dispatch("moveDocument", {
          documentId: droppedDocumentId,
          newParentPath,
          newChildIndex,
        });
      }

      // moveDocument, documentid, newpath
      // aan de hand van documentid de huidige positie afleiden samen met de kinderen, kleinkinderen, etc...
      // Hierop newpath toepasssen
      // Documentpathcache paden updaten
    },
    validateMove(e) {
      if (e.dragChanged) {
        const draggableSlug = e.draggingNode.slug;
        const targetDrop = e.targetPath.parent;
        if (targetDrop) {
          // Not dragging to the root of the space
          const targetChildren = targetDrop.children;
          for (let i = 0; i < targetChildren.length; i++) {
            const element = targetChildren[i];
            if (draggableSlug === element.slug) {
              return false;
            }
          }
        } else {
          // Dragging to the root of the space
          const targetChildren = store.state.activeSpaceTree.children;
          for (let i = 0; i < targetChildren.length; i++) {
            const element = targetChildren[i];

            if (draggableSlug === element.slug) {
              return false;
            }
          }
        }
      }
    },
    showAddDocumentDialog(parent) {
      this.openNewDocumentDialog = true;
      this.newDocumentTitleError = null;
      if (!parent) {
        let p = this.$route.path.split("/");
        p.shift();

        this.parent.path = p.join("/");
      } else {
        this.parent = {
          children: parent.children,
          title: parent.title,
          path: parent.path,
        };
      }
    },
    showRemoveDocumentDialog(parent) {
      this.openRemoveDocumentDialog = true;
      this.parent = parent;
    },
    async createDocument() {
      this.newDocumentTitleError = null;
      try {
        const parent = this.parent;
        console.log(parent);
        const title = this.newDocumentTitle;
        const r = await store.dispatch("createNewDocumentForUser", {
          parent,
          title,
        });
        await router.push(`/${r.activePath}`);
        this.openNewDocumentDialog = false;
      } catch (err) {
        this.newDocumentTitleError = err;
      }
    },
    async navigateToDocument(spaceTree) {
      // navigate to the space + activated url
      await router.push(`/${spaceTree.path}`).catch(() => {});
    },
    async deleteActiveDocument(path) {
      try {
        await store.dispatch("deleteActiveDocument", path);
        await router.replace(`/${path.split("/").slice(0, -1).join("/")}`);
      } catch (err) {
        console.log(err);
      }
      this.openRemoveDocumentDialog = false;
    },
  },
};
</script>
